var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.450801 10.8643C-0.150267 10.2632 -0.150267 9.28872 0.450801 8.68765L8.65688 0.481569C8.97459 0.163858 9.41527 0.0008401 9.86326 0.0353006L14.9162 0.42399C15.6731 0.482214 16.2745 1.08363 16.3328 1.84054L16.7215 6.8935C16.7559 7.34149 16.5929 7.78217 16.2752 8.09988L8.06911 16.306C7.46804 16.907 6.49352 16.907 5.89245 16.306L0.450801 10.8643Z",
    fill: "#3E3E64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1418 4.60647L12.1362 4.60645",
    stroke: "white",
    strokeWidth: 1.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.5f2b142d7fa0afc106c9d4316186ae39.svg";
export { ForwardRef as ReactComponent };